export default __webpack_public_path__ + "static/media/DT3.9e011f7c.jpg";